import { faqEntryEnum } from './uris/faqEntryEnum.default';

const BASE_URI = 'https://faq.manomano.com';

export const getFaqDirection = (id: number) => {
  const urlDetails = faqEntryEnum[id];
  return urlDetails ? `${BASE_URI}/${urlDetails}` : '';
};
